export type TimezoneOption = {
  value: string
  title: string
  hidden?: boolean
}

export const supportalTimeZones = [
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
  "America/Anchorage",
  "Pacific/Honolulu",
  "America/Phoenix",
  "Europe/Amsterdam",
] as const

export type USTimeZone = (typeof supportalTimeZones)[number]

const titleForTimeZone = (timeZone: USTimeZone) => {
  switch (timeZone) {
    case "America/New_York":
      return "New York (Eastern Time)"
    case "America/Chicago":
      return "Chicago (Central Time)"
    case "America/Denver":
      return "Denver (Mountain Time)"
    case "America/Los_Angeles":
      return "Los Angeles (Pacific Time)"
    case "America/Anchorage":
      return "Anchorage (Alaska Time)"
    case "Pacific/Honolulu":
      return "Honolulu (Hawaii Time)"
    case "America/Phoenix":
      return "Phoenix (Arizona Time)"
    case "Europe/Amsterdam":
      return "Amsterdam (Central European Time)"
  }
}

export const usTimeZoneOptions: TimezoneOption[] = supportalTimeZones.map(
  (timeZone) => ({
    value: timeZone,
    title: titleForTimeZone(timeZone),
    hidden: timeZone === "Europe/Amsterdam",
  })
)
